import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import packageJson from '../../_package.json';
import ShortkeyListener from '../../components/shortkey/ShortkeyListener';
import ShortkeyViewer from '../../components/shortkey/ShortkeyViewer';
import { useUser } from '../../hooks/users';

const Footer: React.FC = () => {
  const [showShortkeys, setShowShortkeys] = useState(false);
  const [t] = useTranslation();
  const user = useUser();

  const loggedIn = user ? true : false;
  return (
    <div className="footer">
      <Container>
        <Row>
          <Col md={{ span: 12 }} className="text-center">
            <span>
              {t('Version')}: {packageJson.version}
            </span>
            {' | '}
            <Link to="/term-of-service">{t('Term of Service')}</Link>
            {' | '}
            <Link to="/disclaimer">{t('Disclaimer')}</Link>
            {' | '}
            <Link to="/copyright">{t('Copyright')}</Link>
            {' | '}
            <Link to="/privacy-policy">{t('Privacy Policy')}</Link>
            {' | '}
            <Link to="/contact-us">{t('Contact Us')}</Link>
            {loggedIn && (
              <>
                <span>{' | '}</span>
                {
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      setShowShortkeys(true);
                    }}
                  >
                    {t('Shortkeys')}
                  </a>
                }
              </>
            )}
          </Col>
        </Row>
        <Modal
          show={showShortkeys}
          centered
          onHide={() => setShowShortkeys(false)}
        >
          <Modal.Header>
            <Modal.Title>{t('Shortkeys-modal')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ShortkeyViewer />
          </Modal.Body>
        </Modal>
        <ShortkeyListener
          handleKeys={['shift+/']}
          onKeyEvent={() => setShowShortkeys(true)}
          shortkeys={[
            {
              section: 'global',
              key: '?',
              description: t('view-shortkeys'),
            },
          ]}
        />
      </Container>
    </div>
  );
};

export default React.memo(Footer);
